"use strict";
function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;
//# sourceMappingURL=_setCacheHas.js.map